import { createAsyncThunk } from "@reduxjs/toolkit";

import { handleFetch } from "src/api";
import { BlogType } from "src/shared/config";
import { endPoints } from "src/shared/model";
import { RootState } from "src/app/model/store";

export const getBlogs = createAsyncThunk<BlogType[]>(
  "blogs/getBlogs",
  async () => {
    const response = await handleFetch<undefined, { success: BlogType[] }>({
      url: endPoints.blogs,
      method: "GET",
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.success;
  },
);

export const createBlog = createAsyncThunk<BlogType>(
  "blogs/createBlog",
  async (_, { getState }) => {
    const state = getState() as RootState;
    const newBlog = state.blogs.newBlog;

    const formData = new FormData();
    formData.append("title", newBlog.title);
    formData.append("date", newBlog.date);
    formData.append("description", newBlog.description);
    formData.append("section", newBlog.section);
    formData.append("tags", JSON.stringify(newBlog.tags));

    if (newBlog.image) formData.append("image", newBlog.image);

    return await handleFetch<FormData, BlogType>({
      url: endPoints.blogs,
      method: "POST",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
);
